<div class="flyout box-flyout">
    <div class="chat-body">
        <div class="chat-content {[ if (o.show_send_button) { ]}chat-content-sendbutton{[ } ]}"></div>
        <div class="message-form-container"/>
    </div>
</div>
